import { Injectable } from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TableauReportsService extends DataService {

  private tableauReportsURI = this.apiUri + '/tableaureports/';
  constructor(http: HttpClient) {
    super(http);
  }
  getTableauReports(reportName: string, businessType: string) {
    return this.http.get(this.tableauReportsURI + reportName + '/reportName/' + businessType);
  }
}
